import { render, staticRenderFns } from "./transprotManage.vue?vue&type=template&id=04370d0b&scoped=true"
import script from "./transprotManage.vue?vue&type=script&lang=js"
export * from "./transprotManage.vue?vue&type=script&lang=js"
import style0 from "./transprotManage.vue?vue&type=style&index=0&id=04370d0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04370d0b",
  null
  
)

export default component.exports